<script>
    import Messages from "./helpers/messages/Messages.js";
    import Auth from "./helpers/Auth";

    export let language = 'en-US';
    export let auth_endpoint = '/auth/';

    Messages.registerLanguageVersion(language);

    let email;
    let password;

    let mainError = null;
    let emailError = null;
    let passwordError = null;

    let loading = false;

    const auth = new Auth({
        auth_endpoint
    });

    const signIn = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        emailError = null;
        passwordError = null;

        try {
            const response = await auth.login(email, password);
            if (response.status === 'ok') {
                window.location.href = '/';
            }
        } catch (error) {
            if (error.response.data.errors) {
                if (error.response.data.errors.password) {
                    passwordError = error.response.data.errors.password;
                }

                if (error.response.data.errors.email) {
                    emailError = error.response.data.errors.email;
                }
            }
        }
    }
</script>

<header>
    <a href="/" class="logo {language}"></a>
</header>

<div class="clean-signup-form">
    <form class="auth-form" on:submit = {signIn}>
        {#if mainError}
            <div class="error">{mainError}</div>
        {/if}

        <h1 class="text-center">
            {Messages.t('auth_form', 'TITLE')}
        </h1>

        <p class="text-center">{Messages.t('auth_form', 'MESSAGE')}</p>

        <div class="field-node" class:error = {emailError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_EMAIL')} type="text" name="email" id="email" autocomplete="off" bind:value={email} />
            {#if emailError}
                <div class="error">{emailError}</div>
            {/if}
        </div>

        <div class="field-node" class:error = {passwordError}>
            <input placeholder={Messages.t('form', 'PLACEHOLDER_PASSWORD')} type="password" name="password" id="password" autocomplete="off" bind:value={password} />
            {#if passwordError}
                <div class="error">{passwordError}</div>
            {/if}
        </div>

        <div class="field-node">
            <button class:loading = {loading}>{Messages.t('auth_form', 'BUTTON')}</button>
        </div>

        <div class="field-node text-center">
            <label>
                <a href='/auth/reset-password'>{Messages.t('auth_form', 'UNABLE_TO_ENTER')}</a>
            </label>
        </div>

        <div>
            <div class="field-node text-center">{Messages.t('form', 'SOCIAL_MESSAGE')}</div>
            <div class="field-node text-center socials">
                <div class="ulogin-panel">
                    <div class="ulogin-buttons-container">
                        {#if language === 'ru-RU'}
                            <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://oauth.vk.com/authorize?client_id=51457675&redirect_uri=https%3A%2F%2Fauth.insta-parser.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dvkontakte%26redirectUrl%3Dhttps%253A%252F%252Finsta-parser.ru%252Fauth%252Flogin&response_type=code&scope=email" class="ulogin-button-vkontakte " role="button" title="VK"></div>
                            <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&access_type=online&client_id=161432133356-q0t76ccv847a4qldd06g6omlpaq4ag17.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Finsta-parser.ru%2Fauth%2Fsign-w-google&state&scope=email&approval_prompt=auto" class="ulogin-button-google" role="button" title="Google"></div>
                            <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://oauth.yandex.ru/authorize?client_id=c85c62ff7a7e42d2a15e782670fc5b2c&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dyandex%26redirectUrl%3Dhttps%3A%2F%2Finsta-parser.ru%2Fauth%2Flogin&response_type=code" class="ulogin-button-yandex" role="button" title="Yandex"></div>
                            <div on:click = {(e) => {window.location.href = e.target.getAttribute('data-href')}} data-href = "https://connect.ok.ru/oauth/authorize?client_id=512001803864&redirect_uri=https%3A%2F%2Fauth.zengram.ru%2Foauth%2Fsocial%3Flanguage%3Dru-RU%26network%3Dodnoklassniki%26redirectUrl%3Dhttps%3A%2F%2Finsta-parser.ru%2Fauth%2Flogin&response_type=code&scope=GET_EMAIL" class="ulogin-button-odnoklassniki" role="button" title="Odnoklassniki"></div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        <div class="field-node text-center">
            {Messages.t('auth_form', 'SIGNUP_PHRASE')} <a href="/auth/signup">{Messages.t('auth_form', 'SIGNUP_LINK')}</a>
        </div>
    </form>
</div>

<style lang="scss">
  @import "style";

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/parser/logo.svg) no-repeat center;
    }

    &.en-US {
      background: url(https://auth.avodata.pro/themes/avodata/logo.png) no-repeat center;
    }
  }
</style>